import { useState } from "react";
import PhotoCamera from "@mui/icons-material/PhotoCamera";
import { styled } from "@mui/material/styles";
import { Avatar, Button, Box, TextField } from "@mui/material";
import { UseCountry } from "./UseCountry";
import { useNavigate, useLocation } from "react-router-dom";
import ProgressCom from "../../components/ProgressCom";
import Detail from "../../main/detail/Detail";
import { rsGotoLast, rsProgress, rsActiveMenu } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import useBreakpoints from "../../hooks/useBreakpoints";

function AddCountry(props) {
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const navigate = useNavigate();
  const location = useLocation();
  const [country, setBrand] = useState();
  const { validate, addCountry } = UseCountry();
  const [progress, setProgress] = useRecoilState(rsProgress);
  const { isSmall } = useBreakpoints();

  const handleChangeImage = (evt) => {
    setImgState({
      file: evt.target.files[0],
      url: URL.createObjectURL(evt.target.files[0]),
    });
  };

  const [imgState, setImgState] = useState({ file: undefined, url: undefined });
  const [msGotoLast, setMsGotoLast] = useRecoilState(rsGotoLast);
  const [state, setState] = useState({
    id: undefined,
    faName: undefined,
    enName: undefined,
  });

  const [errorState, setErrorState] = useState({
    faName: false,
    enName: false,
  });
  const Input = styled("input")({
    display: "none",
  });

  return (
    <Detail
      breadChilds={{
        title: "اطلاعات پایه",
        childs: [
          { name: msActiveMenu.pageTitle, url: "/Countries" },
          { name: "ویرایش کشور", url: "/Countries/addcountry" },
        ],
      }}
    >
      {!country ? (
        <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={3}>
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <label
              htmlFor="contained-button-file"
              style={{
                display: "flex",
                flexDirection: "row",
                gap: 3,
                alignItems: "center",
                marginBottom: "10px",
              }}
            >
              <Input
                accept="image/*"
                id="contained-button-file"
                multiple
                type="file"
                onChange={handleChangeImage}
              />
              <PhotoCamera color="secondary" />
              <Avatar sx={{ objectFit: "cover" }} src={imgState.url} />
            </label>
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <TextField
              value={state.faName ? state.faName : ""}
              error={errorState.faName}
              sx={{
                width: "100%",
              }}
              label="نام فارسی"
              size="small"
              variant="outlined"
              onChange={(evt) => {
                setState({ ...state, faName: evt.target.value });
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <TextField
              value={state.enName ? state.enName : ""}
              error={errorState.enName}
              sx={{
                width: "100%",
                input: { direction: "rtl" },
              }}
              label="نام لاتین"
              size="small"
              variant="outlined"
              onChange={(evt) => {
                setState({ ...state, enName: evt.target.value });
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>{" "}
          {!isSmall && <Box gridColumn="span 9"></Box>}
          <Box
            gridColumn={isSmall ? "span 12" : "span 3"}
            sx={{ display: "flex", justifyContent: "flex-end" }}
          >
            <Button
              sx={{ mr: 2, width: "100px" }}
              variant="contained"
              color="secondary"
              onClick={() => {
                if (validate(state, setErrorState) == 200) {
                  setProgress(true);
                  setMsGotoLast(true);
                  addCountry(state, imgState.file, () => {
                    navigate("/Countries", {
                      state: { ...location.state, isBack: true },
                      replace: true,
                    });
                  });
                }
              }}
            >
              ثبت
            </Button>
            <Button
              sx={{ width: "100px" }}
              variant="outlined"
              color="secondary"
              onClick={() => {
                navigate("/Countries", {
                  state: { ...location.state, isBack: true },
                  replace: true,
                });
              }}
            >
              بازگشت
            </Button>
          </Box>
        </Box>
      ) : (
        <ProgressCom></ProgressCom>
      )}
    </Detail>
  );
}

export default AddCountry;
